// Handle videos in apage
(function($){

    $(document).on("click", '.card--has-video .card__image, .card--has-video .yr-card-image, .icon-Meta_Video .sigil__icon', function(e) { 
        e.preventDefault();
        e.stopPropagation();
        var videoCard = $(this).parents('.card--has-video');
        var videoContainer = videoCard.find('.card__embed__video__container');
        var videoEmbedCode = videoContainer.data('videocode');
        var currentVideoCard = $('.card--video-loaded');
        var currentVideoContainer = currentVideoCard.find('.card__embed__video__container');

        currentVideoCard.removeClass('card--video-loaded').find('.card__image, .post-image').show();
        currentVideoContainer.hide().data('videocode', escape(currentVideoContainer.html())).html('');
        videoCard.find('.card__image, .post-image').hide();
        videoContainer.html(unescape(videoEmbedCode)).promise().done(function(){
            videoCard.addClass('card--video-loaded');
            videoContainer.show();
        });
            
    });

})(jQuery);
